/**
 * 与 HeroUI `Text` 组件 typography 对齐（字号 / 字重 / 行高 / 字距）。
 * 标题含 min-h，避免空标题 DOM 高度为 0 导致 placeholder 不可见。
 */

/** HeroUI Text `body`：16px / 400 / line-height 1.75 */
export const LEXICAL_BODY_TYPOGRAPHY_CLASSES = "text-base font-normal leading-[1.75]";

/** HeroUI Text `body-xs`：12px / 400 / line-height 1.25 */
export const LEXICAL_BODY_XS_TYPOGRAPHY_CLASSES = "text-[12px] font-normal leading-[1.25]";

export const LEXICAL_HEADING_TYPOGRAPHY_CLASSES: Record<"h1" | "h2" | "h3" | "h4" | "h5" | "h6", string> = {
  h1: "text-[28px] font-semibold leading-[1.11] tracking-tight min-h-[40px]",
  h2: "text-[26px] font-semibold leading-[1.17] tracking-tight min-h-[36px]",
  h3: "text-[24px] font-semibold leading-[1.25] tracking-tight min-h-[30px]",
  h4: "text-[20px] font-semibold leading-[1.33] tracking-tight min-h-[27px]",
  h5: "text-[18px] font-semibold leading-[1.39] tracking-tight min-h-[26px]",
  h6: "text-[16px] font-semibold leading-[1.5] tracking-tight min-h-[24px]",
};

export function getLexicalTheme() {
  // 直接使用 tailwind 类名，避免额外 css 文件
  return {
    paragraph: `rt-paragraph ${LEXICAL_BODY_TYPOGRAPHY_CLASSES}`,
    heading: {
      h1: `rt-h1 ${LEXICAL_HEADING_TYPOGRAPHY_CLASSES.h1}`,
      h2: `rt-h2 ${LEXICAL_HEADING_TYPOGRAPHY_CLASSES.h2}`,
      h3: `rt-h3 ${LEXICAL_HEADING_TYPOGRAPHY_CLASSES.h3}`,
      h4: `rt-h4 ${LEXICAL_HEADING_TYPOGRAPHY_CLASSES.h4}`,
      h5: `rt-h5 ${LEXICAL_HEADING_TYPOGRAPHY_CLASSES.h5}`,
      h6: `rt-h6 ${LEXICAL_HEADING_TYPOGRAPHY_CLASSES.h6}`,
    },
    text: {
      bold: "rt-bold font-bold",
      italic: "rt-italic italic",
      underline: "rt-underline underline",
      strikethrough: "rt-strikethrough line-through",
      superscript: `rt-superscript align-super ${LEXICAL_BODY_XS_TYPOGRAPHY_CLASSES}`,
      subscript: `rt-subscript align-sub ${LEXICAL_BODY_XS_TYPOGRAPHY_CLASSES}`,
    },
    link: "rt-link text-[var(--accent)] underline decoration-[var(--accent)]/50",
    list: {
      ul: "rt-ul list-disc pl-6",
      ol: "rt-ol list-decimal pl-6",
      listitem: `rt-li ${LEXICAL_BODY_TYPOGRAPHY_CLASSES}`,
      nested: {
        list: "rt-nested-list",
        listitem: `rt-nested-list-item ${LEXICAL_BODY_TYPOGRAPHY_CLASSES}`,
      },
    },
    // TablePlugin hasHorizontalScroll：包裹 table 的滚动容器，缺此 key 会在控制台告警
    // min-w-0：在 flex 子项上允许窄于表格内容宽，否则 min-width:auto 会把整块撑开、无法出现横向滚动
    tableScrollableWrapper: "rt-table-scroll-wrapper min-w-0 overflow-x-auto",
  };
}
